import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";

import { AppContext } from "@/providers";
import { redirectPlayerIfSignUpNotFinished } from "@/utils";

import { Statistics } from "./components/Statistics";
import { QuickActions } from "./components/QuickActions";
import { NeedsAttention } from "./components/NeedsAttention";
import { ReadyToPost } from "./components/ReadyToPost";

import { PageWrapper } from "@/components/PageWrapper";

type Props = RouteComponentProps;

const DashboardFC: React.FC<Props> = () => {
  const { userContext } = React.useContext(AppContext);

  const playerId = userContext!!.player!!.id;

  React.useEffect(() => {
    redirectPlayerIfSignUpNotFinished(userContext);
  }, [userContext]);

  return (
    <PageWrapper>
      <div className={"flex flex-col gap-8"}>
        <Statistics playerId={playerId} coachId={Number(userContext!!.subscriptions!![0].pricePlan.coachId)} />
        <QuickActions playerId={playerId} />
        <NeedsAttention playerId={playerId} />
        <ReadyToPost playerId={playerId} />
      </div>
    </PageWrapper>
  );
};

export const PlayerDashboard = withRouter(DashboardFC);
